module.exports = {
    aria: 1,
    'classNames': {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    classes: 1,
    delay: 0,
    events: 'input|blur',
    useConstraintAttrs: false,
    dictionary: {
        en: {
            attributes: {
                vin: 'VIN',
                license_plate: 'license plate',
                vhr: 'vehicle history',
                full_name: 'full name',
                first_name: 'first name',
                last_name: 'last name',
                vehicle_type: 'vehicle type',
            },
            messages: {
                alpha_num: (field) => `The ${field} field may only contain letters and numbers.`,
                digits: (field, [length]) => `The ${field} field must be ${length} digits.`,
                length: (field, [length, max]) => {
                    if (max) {
                        return `The ${field} length must be between ${length} and ${max}.`;
                    }
                    return `${field} must have ${length} characters.`;
                },
                numeric: (field) => {
                    return `${field} must be a number.`;
                },
                ext: (field) => `The ${field} file must be a valid format.`,
            },
            custom: {
                accutrade_id: {
                    required: 'You must make a selection.'
                },
                response: {
                    required: 'Your response is required.'
                }
            }
        },

    }
}
